import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import html2pdf from "html2pdf.js";
import { getAllRetailers } from "../../services/retailer.service";
import { useSelector } from "react-redux";
import { getAllDesignRates } from "../../services/ratediary.service";
import {
  addCartItem,
  deleteCartItem,
  getAllCartItems,
  updateCartItem,
} from "../../services/cart.service";
import DeleteButton from "../common/DeleteButton";
import {
  applyCoupon,
  createOrder,
  getAllOrders,
  increaseByTen,
} from "../../services/order.service";

export default function AddPlaceOrder() {
  const { token } = useSelector((state) => state?.auth);
  const [isLoading2, setIsLoading2] = useState(false);
  const orderFormRef = useRef(null);
  const [today, setToday] = useState(null);
  const [retailers, setRetailers] = useState([]);
  const [rateDiary, setRateDiary] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [total, setTotal] = useState(null);
  const [cart, setCart] = useState(null);
  const [retailer, setRetailer] = useState(null);
  const [lastOrderId, setLastOrderId] = useState(null);
  const [coupon, setCoupon] = useState(null);
  const [checkboxValue, setCheckboxValue] = useState(false);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm();

  const fetchRetailers = async (page = false) => {
    try {
      const params = { page };
      const res = await getAllRetailers(token, params);
      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        setRetailers(res?.data || []);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch Retailer. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching Retailer:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const fetchCartItems = async (userId) => {
    try {
      const res = await getAllCartItems(token, userId);
      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);
        setCart(res?.data);
        if (coupon) {
          handleApplyCoupon(null);
        } else {
          setTotal(res?.data);
        }
        setCartItems(res?.data?.items);
      } else {
        console.log("Failed to fetch cart");
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  };

  const handleApplyCoupon = async (message) => {
    try {
      // Prepare data for the applyCoupon request
      const data = {
        user_id: retailer?.value,
        coupon_code: watch("couponCode"),
      };

      // Call applyCoupon API
      const res = await applyCoupon(token, data);

      if (!res || res.status < 200 || res.status >= 300) {
        console.error("Failed to apply coupon:", res);
        setCoupon(null);
        Swal.fire(
          "Error",
          res?.data?.message ||
            res?.data?.error ||
            "Failed to apply coupon. Please try again.",
          "error"
        );

        try {
          const res = await getAllCartItems(token, retailer?.value);

          if (res?.status >= 200 && res?.status < 300) {
            // console.log(res.data);
            setCart(res.data);
            setCartItems(res.data.items);
            setTotal(res.data);
          } else {
            console.error("Failed to fetch cart:", res);
          }
        } catch (error) {
          console.error("Error fetching cart:", error);
        }
        return;
      }

      console.log("Coupon applied successfully:", res.data);
      setTotal(res?.data);
      setCoupon(watch("couponCode"));
      if (message) {
        Swal.fire("Success", message, "success");
      }
    } catch (error) {
      console.error("Error applying coupon:", error);
      alert("An error occurred while applying the coupon. Please try again.");
    } finally {
      console.log("end");
      
    }
  };

  const fetchLastOrder = async () => {
    try {
      const params = { last_order: "True" };
      const res = await getAllOrders(token, params);
      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);
        setLastOrderId(res?.data?.last_order?.order_id);
      } else {
        console.log("Failed to fetch last order");
      }
    } catch (error) {
      console.error("Error fetching last order:", error);
    }
  };

  useEffect(() => {
    fetchRetailers();
  }, []);

  const retailerOptions = [
    ...retailers.map((retailer) => ({
      value: retailer.retailer_id,
      label: retailer.retailer_name,
      added_by: retailer?.added_by,
    })),
    { value: "addRetailer", label: "Add Retailer", isAddOption: true },
  ];

  const customStyles = {
    option: (provided, state) => {
      if (state.data.isAddOption) {
        return {
          ...provided,
          backgroundColor: "#4baebc",
          fontWeight: "bold",
          color: "white",
          cursor: "pointer",
        };
      }
      return provided;
    },
  };

  const customFilterOption = (candidate, input) => {
    if (candidate.data.isAddOption) {
      return true;
    }
    return candidate?.label?.toLowerCase().includes(input.toLowerCase());
  };

  // console.log(retailer);

  const handleRetailerChange = async (selectedOption) => {
    clearErrors("retailer");
    setRetailer(selectedOption);
    setToday(new Date().toISOString().split("T")[0]);
    setValue("retailer", selectedOption);
    setCartItems(null);
    setCheckboxValue(false);
    setCoupon(null)
    setValue("couponCode", null)
    console.log(selectedOption);

    if (selectedOption?.value === "addRetailer") {
      navigate("/retailer/add");
    } else if (selectedOption) {
      fetchCartItems(selectedOption?.value);
      handleCheckboxChange(false, selectedOption?.value, null);
      fetchLastOrder();
    }
  };

  // const handleAddProduct = async (barcodeData) => {
  //   if (!retailer) {
  //     alert("Please select a retailer!");
  //     return;
  //   }

  //   if (!barcodeData) {
  //     alert("Please scan a barcode!");
  //     return;
  //   }

  //   console.log("Scanning barcode:", barcodeData);

  //   try {
  //     const params = { design_id: barcodeData };
  //     const res = await getAllDesignRates(token, params);

  //     if (!res || res.status < 200 || res.status >= 300) {
  //       console.error("Failed to fetch design rates:", res);
  //       alert(
  //         res?.data?.message ||
  //           res?.data?.error ||
  //           "Failed to fetch design ID. Please try again."
  //       );
  //       return;
  //     }

  //     console.log("Fetched design rates:", res.data);

  //     if (!res.data) return;

  //     const cartData = {
  //       user_id: retailer?.value,
  //       quantity: 1,
  //       design_id: barcodeData,
  //     };

  //     try {
  //       const cartRes = await addCartItem(token, cartData);

  //       if (cartRes && cartRes.status >= 200 && cartRes.status < 300) {
  //         console.log("Added to cart:", cartRes.data);
  //         fetchCartItems(retailer?.value);
  //       } else {
  //         console.error("Failed to add item to cart:", cartRes);
  //       }
  //     } catch (cartError) {
  //       console.error("Error adding to cart:", cartError);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching design rates:", error);
  //   } finally {
  //     setValue("designID", "");
  //   }
  // };

  // console.log(cart);
  // console.log(retailer);

  // Barcode Scanner Code
  // useEffect(() => {
  //   let barcodeBuffer = "";
  //   let debounceTimeout;

  //   const handleKeyDown = (evt) => {
  //     if (debounceTimeout) clearTimeout(debounceTimeout);

  //     if (evt.code === "Enter") {
  //       if (barcodeBuffer) {
  //         handleBarcode(barcodeBuffer);
  //         barcodeBuffer = "";
  //       }
  //       return;
  //     }

  //     if (evt.key !== "Shift") {
  //       barcodeBuffer += evt.key;
  //     }

  //     debounceTimeout = setTimeout(() => {
  //       barcodeBuffer = "";
  //     }, 50);
  //   };

  //   const handleBarcode = (scannedBarcode) => {
  //     handleAddProduct(scannedBarcode); // Pass the scanned barcode to the handler
  //   };

  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //     if (debounceTimeout) clearTimeout(debounceTimeout);
  //   };
  // }, [handleAddProduct]);

  // console.log(cart);

  const handleUpdateQuantity = async (item, newQuantity) => {
    // console.log(item, newQuantity);

    const updatedProducts = cartItems.map((product) =>
      product.design_id === item.design_id
        ? { ...product, quantity: "", total_price: 0 }
        : product
    );

    setCartItems(updatedProducts);

    if (item) {
      try {
        const cartId = cart?.cart_id;
        const cartItemId = item?.cart_item_id;

        const data = {
          quantity: newQuantity || null,
        };

        // console.log(data);

        const res = await updateCartItem(token, data, cartId, cartItemId);

        if (res && res.status >= 200 && res.status < 300) {
          const hasBlankQuantities = cartItems.some(
            (item) =>
              item.quantity === null ||
              item.quantity <= 0 ||
              item.quantity === ""
          );

          if (!hasBlankQuantities) {
            if (checkboxValue) {
              handleCheckboxChange(
                false,
                retailer?.value,
                "Increased value by 10 is removed because change in retailer cart"
              );
            }
            if (coupon) {
              handleApplyCoupon(null);
            } else {
              setTotal(res?.data);
            }
          }
          console.log("Cart item updated:", res.data);
        } else {
          console.log("Failed to update cart item");
        }
      } catch (error) {
        console.log("Error updating cart item:", error);
      }
    }

    const updatedCartItems = cartItems.map((cartItem) =>
      cartItem.design_id === item.design_id
        ? {
            ...cartItem,
            quantity: newQuantity,
            total_price: newQuantity * cartItem.product.price || 0,
          }
        : cartItem
    );

    setCartItems(updatedCartItems);
  };

  const handleDelete = async (item) => {
    const cartId = cart?.cart_id;
    const cartItemId = item?.cart_item_id;
    const userId = retailer?.value;

    console.log(item);

    try {
      const res = await deleteCartItem(token, cartId, cartItemId);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Deleted!",
          text: `${item?.product?.product_name} Product has been deleted successfully.`,
          icon: "success",
        }).then(() => {
          fetchCartItems(userId);
          if (checkboxValue) {
            handleCheckboxChange(
              false,
              retailer?.value,
              "Increased value by 10 is removed because change in retailer cart"
            );
          }
        });
      } else {
        Swal.fire(
          "Error",
          res?.data?.detail ||
            "Failed to delete the Product. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during product deletion:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const handleModifyAllQuantities = () => {
    const updatedProducts = cartItems.map((product) => ({
      ...product,
      quantity: "",
      total_price: 0,
    }));

    // console.log(updatedProducts);
    setTotal(null);
    setCartItems(updatedProducts);
  };

  const onSave = () => {
    const hasBlankQuantities = cartItems.some(
      (item) =>
        item.quantity === null || item.quantity <= 0 || item.quantity === ""
    );

    if (hasBlankQuantities) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          "Please make sure all quantities are filled and greater than zero.",
      });
    } else {
      Swal.fire({
        title: "Cart Saved",
        text: "Your cart has been successfully saved.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        fetchCartItems(retailer?.value); // Refresh cart items after save
      });
    }
  };

  const onSubmit = async (item) => {
    console.log(item);
  };

  const handleEnterAddProduct = async (item) => {
    console.log("item:", item);

    if (!retailer) {
      alert("Please select a retailer!");
      return;
    }

    try {
      const params = { design_id: item };
      const res = await getAllDesignRates(token, params);

      if (!res || res.status < 200 || res.status >= 300) {
        console.error("Failed to fetch design rates:", res);
        alert(
          res?.data?.message ||
            res?.data?.error ||
            "Failed to fetch design ID. Please try again."
        );
        return;
      }

      console.log("Fetched design rates:", res.data);

      if (!res.data) return;

      const cartData = {
        user_id: retailer?.value,
        quantity: 1,
        design_id: item,
      };

      try {
        const cartRes = await addCartItem(token, cartData);

        if (cartRes && cartRes.status >= 200 && cartRes.status < 300) {
          console.log("Added to cart:", cartRes.data);
          fetchCartItems(retailer?.value);
          if (checkboxValue) {
            handleCheckboxChange(
              false,
              retailer?.value,
              "Increased value by 10 is removed because change in retailer cart"
            );
          }
        } else {
          console.error("Failed to add item to cart:", cartRes);
        }
      } catch (cartError) {
        console.error("Error adding to cart:", cartError);
      }
    } catch (error) {
      console.error("Error fetching design rates:", error);
    } finally {
      setValue("designID", "");
    }
  };

  const handlePlaceOrder = async () => {
    setIsLoading2(true);

    // const data = retailer?.added_by?.id
    //   ? {
    //       agent_id: retailer?.added_by?.id,
    //     }
    //   : null;

    // const data =
    //   retailer?.added_by?.role === "Admin"
    //     ? null
    //     : retailer?.added_by?.id
    //     ? { agent_id: retailer.added_by.id }
    //     : null;

    let data = null;

    if (retailer?.added_by?.role !== "Admin") {
      data = { agent_id: retailer?.added_by?.id };
    }

    if (coupon) {
      data = data ? { ...data, coupon_code: coupon } : { coupon_code: coupon };
    }

    // console.log(data);

    try {
      const retaileId = retailer?.value;
      const res = await createOrder(token, data, retaileId);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        Swal.fire({
          title: "Order Placed!",
          text: `Your order has been placed successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          retailer?.added_by?.role !== "Admin" && retailer?.added_by?.id
            ? navigate("/agent/agent-order")
            : navigate("/place-order");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire({
          title: "Error",
          html: res?.data?.error
            ? `The following products have insufficient quantity: <br><br><div style="font-size: 14px;">${res?.data?.insufficient_items
                ?.map((item) => {
                  const matchedCartItem = cartItems?.find(
                    (cartItem) => cartItem?.product?.product_name === item.name
                  );
                  return `${item.name} (Design ID: ${matchedCartItem?.design_id ?? "N/A"}) - Qty Available ${item.stock_available}`;
                })
                .join("<br>")}</div>`
            : "Invalid order details. Please check your input.",
          icon: "error",
        });
      } else {
        Swal.fire(
          "Error",
          res?.data?.error ||
            "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error placing order:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  const handlePrint = () => {
    const element = document.getElementById("orderFormToPrint");

    const opt = {
      margin: 0,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, backgroundColor: "#ffffff" }, // White background for better printing
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const blobUrl = URL.createObjectURL(pdf.output("blob"));
        const printWindow = window.open(blobUrl, "_blank");

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.onafterprint = () => {
              printWindow.close();
            };
          };
        }
      });
  };

  // const handleCheckboxChange = async (checkedValue) => {
  //   setCheckboxValue((prevValue) => !prevValue);

  //   console.log(checkedValue);

  //   const data = {
  //     increase_by_ten: checkedValue ? "yes" : "no",
  //   };

  //   try {
  //     const res = await increaseByTen(token, data, retailer?.value);

  //     if (res.status >= 200 && res.status < 300) {
  //       // console.log(res.data);
  //       fetchCartItems(retailer?.value);
  //     } else {
  //       console.error("Failed to increase by ten:", res.data);
  //     }
  //   } catch (error) {
  //     console.log("Error while calling increaseByTen:", error);
  //   }
  // };

  const handleCheckboxChange = async (isChecked, userId, message) => {
    setCheckboxValue(isChecked); // Update the checkbox value

    console.log("Checkbox Value:", isChecked);

    const data = {
      increase_by_ten: isChecked ? "yes" : "no",
    };

    try {
      const res = await increaseByTen(token, data, userId);
      // console.log(res);

      if (res.status >= 200 && res.status < 300) {
        if (!isChecked && message) {
          Swal.fire({
            title: "Warning!",
            text: message,
            icon: "warning",
          });
        }
        console.log("API Response:", res.data);
        fetchCartItems(userId); // Refresh cart items
      } else {
        console.error("Failed to increase by ten:", res.data);
      }
    } catch (error) {
      console.error("Error while calling increaseByTen:", error);
    }
  };
  // console.log(checkboxValue);

  return (
    <div className="content-body">
      {/* Download Order Form */}
      <div
        className="modal fade"
        id="orderFormDownload"
        tabindex="-1"
        aria-labelledby="orderFormDownloadModalTitle"
        aria-hidden="true"
      >
        <div id="orderFormToPrint" className="">
          {/* d-none */}

          <div className="body3">
            <div className="container3">
              <div className="row" ref={orderFormRef}>
                <div className="text-left mb-4">
                  <p className="mb-0">{lastOrderId + 1}</p>
                  <p className="mb-0">
                    {new Date()
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "2-digit",
                      })
                      .replaceAll(" ", "-")}
                  </p>
                  <p className="fw-bold mb-0">{cart?.owner_name}</p>
                  <p>
                    {cart?.shop_name}, {cart?.address}
                  </p>
                </div>

                {/* <!-- Download Order Form --> */}
                <div className="d-flex flex-wrap">
                  {/* <!-- Single Block --> */}
                  {cartItems &&
                    cartItems?.length > 0 &&
                    cartItems?.map((item, i) => (
                      <>
                        <div className="mini-box"></div>
                        <div className="custom-col p-1 text-left">
                          <p className="pb-2" style={{ fontSize: "smaller" }}>
                            {item.product.brand}
                          </p>
                          <div className="d-flex justify-content-between">
                            <p
                              className="fw-bold mb-1"
                              style={{ fontSize: "small" }}
                            >
                              {item.product.design_no}
                            </p>
                            <p
                              className="fw-bold mb-1"
                              style={{ fontSize: "small" }}
                            >
                              {item.product.size}
                            </p>
                          </div>
                          <hr className="my-0" />
                          <p className="text-center mb-0">
                            1@
                            {(item.product.price * 1).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                      </>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Download Order Form */}

      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card" style={{ minHeight: "500px" }}>
              <div className="card-header">
                <h4 className="card-title">Place New Order</h4>
                <Link to="/place-order">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="mb-4 col-sm-3">
                        <div className="d-flex">
                          <label className="form-label">Retailer Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <Select
                          options={retailerOptions}
                          {...register("retailer", {
                            required: "Retailer is required",
                          })}
                          onChange={handleRetailerChange}
                          placeholder="Select a Retailer"
                          isClearable
                          styles={customStyles}
                          filterOption={customFilterOption}
                        />
                        {errors.retailer && (
                          <p className="error">{errors.retailer.message}</p>
                        )}
                      </div>

                      <div className="mb-4 col-sm-3">
                        <label className="form-label">Design ID</label>
                        {/* <input
                          type="text"
                          className="form-control"
                          {...register("designID")}                        /> */}
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Design ID"
                          {...register("designID")}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleEnterAddProduct(e.target.value);
                            }
                          }}
                        />
                      </div>

                      <div className="mb-4 col-sm-3">
                        <label className="form-label">Order ID</label>
                        <input
                          type="text"
                          className="form-control"
                          value={
                            lastOrderId
                              ? lastOrderId + 1
                              : retailer?.value
                              ? 1
                              : null
                          }
                          placeholder="Order ID"
                          {...register("orderID", {
                            required: "Order ID is required",
                          })}
                          disabled
                        />
                        {errors.orderID && (
                          <p className="error">{errors.orderID.message}</p>
                        )}
                      </div>

                      <div className="mb-4 col-sm-3">
                        <label className="form-label">Order Date</label>
                        <input
                          type="date"
                          defaultValue={today}
                          className="form-control"
                          {...register("orderDate", {
                            required: "Order Date is required",
                          })}
                          disabled
                        />
                        {errors.orderDate && (
                          <p className="error">{errors.orderDate.message}</p>
                        )}
                      </div>

                      {cartItems && cartItems?.length > 0 && (
                        <div className="">
                          <form
                            id="OrderForm"
                            data-form-label="OrderForm"
                            // onSubmit={handleSubmitFeeCalculation(calculateShipping)}
                          >
                            <div className="modal-body p-0">
                              <div className="mt-3 p-0">
                                {/* Order Form */}
                                <div className="d-flex ">
                                  {/* Product Table */}
                                  <div className="table-responsive flex-grow-1 border-right">
                                    <table className="table">
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Name</th>
                                          <th>Design ID</th>
                                          <th>Quantity</th>
                                          <th>Price</th>
                                          <th>Total</th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {cartItems?.map((item, index) => (
                                          <tr key={item.design_id}>
                                            <td>{index + 1}</td>
                                            <td>{item.product.product_name}</td>
                                            <td>{item.design_id}</td>
                                            <td>
                                              <input
                                                type="number"
                                                min="1"
                                                value={item.quantity}
                                                onChange={(e) =>
                                                  handleUpdateQuantity(
                                                    item,
                                                    parseInt(e.target.value, 10)
                                                  )
                                                }
                                                className="order-input"
                                              />
                                            </td>
                                            <td>
                                              ₹
                                              {(
                                                item?.product?.price * 1
                                              )?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </td>
                                            <td>
                                              ₹
                                              {(
                                                item?.total_price * 1
                                              )?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </td>
                                            <td>
                                              <DeleteButton
                                                name={`Product`}
                                                onDelete={() =>
                                                  handleDelete(item)
                                                }
                                                hide={true}
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>

                                  {/* Action Buttons */}
                                  <div className="d-flex flex-column ms-3">
                                    <div className="d-flex">
                                      <img
                                        src="/assets/images/kidskart/icon/printer.png"
                                        alt="Print Icon"
                                        className="cursor-pointer me-3"
                                        onClick={handlePrint}
                                        title="Print Order Form"
                                      />
                                    </div>
                                    <button
                                      className="btn px-2 py-1 fw-bold btn-dark mt-5"
                                      // style={{position: "absolute", top: "100px", right: "10px"}}
                                      onClick={handleModifyAllQuantities}
                                      type="button"
                                    >
                                      Modify
                                    </button>
                                    <button
                                      className="btn px-2 py-1 fw-bold btn-danger mt-2"
                                      // style={{position: "absolute", top: "100px", right: "10px"}}
                                      onClick={() => onSave()}
                                      type="button"
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer"></div>
                          </form>
                        </div>
                      )}

                      <div className="row ">
                        {/* <div className="mt-4 text-center">
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={isLoading}
                        >
                          {isLoading ? "Adding Order..." : "Add Order"}
                        </button>
                      </div> */}
                      </div>
                    </div>
                  </form>

                  <div className=" row">
                    <div className="col-md-6 p-3">
                      {cartItems?.length > 0 && (
                        <div>
                          <div className="border">
                            <div className="d-flex justify-content-between p-0 px-3 mt-2">
                              <p className="m-0">Sub Total:</p>
                              <p className="m-0">
                                ₹
                                {total
                                  ? (total?.subtotal * 1)?.toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }
                                    )
                                  : 0}
                              </p>
                            </div>
                            {total?.discount > 0 && (
                              <div className="d-flex justify-content-between p-0 px-3">
                                <p className="m-0">Discount:</p>
                                <p className="m-0">
                                  -₹
                                  {total
                                    ? (total?.discount * 1)?.toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : 0}
                                </p>
                              </div>
                            )}
                            <div className="d-flex justify-content-between p-0 px-3">
                              <p className="m-0">Tax:</p>
                              <p className="m-0">
                                ₹
                                {total
                                  ? (total?.tax * 1)?.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : 0}
                              </p>
                            </div>
                            <div className="d-flex justify-content-between p-0 px-3">
                              <p className="m-0">Shipping Fee:</p>
                              <p className="m-0">
                                ₹
                                {total
                                  ? (
                                      (total?.shipping_price ||
                                        total?.shipping_fee) * 1
                                    )?.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                  : 0}
                              </p>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between p-0 mb-3 px-3">
                              <p className="m-0">
                                <strong>Grand Total</strong>
                              </p>
                              <p className="m-0">
                                <strong>
                                  ₹
                                  {total
                                    ? (total?.final_amount * 1)?.toLocaleString(
                                        "en-IN",
                                        {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        }
                                      )
                                    : 0}
                                </strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Right Side Summary */}
                    <div className="col-md-5" style={{ marginTop: "10px" }}>
                      {cartItems?.length > 0 && (
                        <div>
                          <div className="form-check mt-1">
                            <input
                              type="checkbox"
                              id="exampleCheckbox"
                              className="form-check-input"
                              checked={checkboxValue}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                handleCheckboxChange(
                                  isChecked,
                                  retailer?.value,
                                  null
                                );
                              }}
                            />
                            <label
                              htmlFor="exampleCheckbox"
                              className="form-check-label mt-1"
                            >
                              Increase value by 10
                            </label>
                          </div>
                          {/* <label className="mt-1">Apply Coupon</label> */}
                          <div className="row mt-3">
                            <div className="col-sm-8">
                              <input
                                placeholder="Enter Coupon Code"
                                className="form-control"
                                {...register("couponCode")}
                              />
                            </div>
                            <div className="col-sm-4">
                              <button
                                className="btn btn-dark w-100 fw-bold mt-1"
                                onClick={() =>
                                  handleApplyCoupon(
                                    "Coupon has been successfully applied!"
                                  )
                                }
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                          {/* Price Summary Card */}
                          {!isLoading2 ? (
                            <div className="mt-4">
                              <button
                                type="button"
                                className="btn btn-primary w-100 mr-2"
                                onClick={handlePlaceOrder}
                              >
                                PLACE ORDER
                              </button>
                            </div>
                          ) : (
                            <div className="mt-4">
                              <button
                                type="button"
                                className="btn btn-primary w-100 mr-2"
                                disabled
                              >
                                PROCESSING...
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
